// Translation: Interface > Pagination (Turkish)
export default Object.freeze({
	options: {
		first: {
			label: 'İlk'
		},
		last: {
			label: 'Son'
		},
		next: {
			label: 'Sonraki'
		},
		previous: {
			label: 'Önceki'
		}
	}
})
